export default function ProcessSection() {
  const steps = [
    {
      number: '01',
      title: 'Contact Us',
      description: 'Call us at (915) 206-5814 or fill out our contact form. Tell us about your apartment building—location, number of units, condition, and your timeline for selling.',
      icon: 'ri-phone-fill'
    },
    {
      number: '02',
      title: 'Property Evaluation',
      description: 'We\'ll schedule a convenient time to view your property. Our team evaluates the building, reviews rent rolls, operating expenses, and assesses the overall condition and income potential.',
      icon: 'ri-search-eye-fill'
    },
    {
      number: '03',
      title: 'Cash Offer Presentation',
      description: 'Within 24-48 hours, we\'ll present you with a fair, all-cash offer. We explain our valuation methodology and answer all your questions. No pressure, no obligations.',
      icon: 'ri-file-text-fill'
    },
    {
      number: '04',
      title: 'Accept & Open Escrow',
      description: 'If you accept our offer, we immediately open escrow with a reputable title company. They handle all paperwork, title searches, lien resolution, and legal documentation.',
      icon: 'ri-shield-check-fill'
    },
    {
      number: '05',
      title: 'Title Company Process',
      description: 'The title company conducts their due diligence, clears any title issues, prepares closing documents, and coordinates with all parties. We stay in close communication throughout.',
      icon: 'ri-file-list-3-fill'
    },
    {
      number: '06',
      title: 'Close & Get Paid',
      description: 'We close in 7-14 days at the title company office. You sign the documents, receive your cash payment via wire transfer or cashier\'s check, and we handle the rest.',
      icon: 'ri-money-dollar-circle-fill'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-block bg-teal-100 text-teal-700 px-4 py-2 rounded-full text-sm font-semibold mb-6">
            Our Process
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            How to Sell My Apartments Fast: Our 6-Step Process
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            We've streamlined the apartment selling process to be fast, transparent, and secure. Every transaction is handled through a title company for your protection.
          </p>
        </div>

        <div className="relative">
          {/* Connection Line */}
          <div className="hidden lg:block absolute left-1/2 top-0 bottom-0 w-1 bg-gradient-to-b from-teal-200 via-teal-400 to-teal-200 transform -translate-x-1/2"></div>

          <div className="space-y-12">
            {steps.map((step, index) => (
              <div 
                key={index}
                className={`flex flex-col lg:flex-row items-center gap-8 ${
                  index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'
                }`}
              >
                <div className="flex-1">
                  <div className={`bg-white rounded-2xl p-8 shadow-xl hover:shadow-2xl transition-all duration-300 ${
                    index % 2 === 0 ? 'lg:text-right' : 'lg:text-left'
                  }`}>
                    <div className={`inline-block bg-teal-100 text-teal-700 px-4 py-2 rounded-full text-sm font-bold mb-4`}>
                      Step {step.number}
                    </div>
                    <h3 className="text-2xl font-bold text-gray-900 mb-4">{step.title}</h3>
                    <p className="text-gray-600 leading-relaxed text-lg">{step.description}</p>
                  </div>
                </div>

                <div className="relative z-10">
                  <div className="w-20 h-20 bg-gradient-to-br from-teal-500 to-teal-600 rounded-full flex items-center justify-center shadow-xl">
                    <i className={`${step.icon} text-white text-3xl`}></i>
                  </div>
                </div>

                <div className="flex-1 hidden lg:block"></div>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-16 bg-gradient-to-r from-teal-600 to-teal-700 rounded-2xl p-12">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="text-white">
              <h3 className="text-3xl font-bold mb-4">Why Our Process Works</h3>
              <ul className="space-y-4">
                <li className="flex items-start space-x-3">
                  <i className="ri-checkbox-circle-fill text-2xl text-teal-200 flex-shrink-0 mt-1"></i>
                  <span className="text-lg">All transactions handled through reputable title companies</span>
                </li>
                <li className="flex items-start space-x-3">
                  <i className="ri-checkbox-circle-fill text-2xl text-teal-200 flex-shrink-0 mt-1"></i>
                  <span className="text-lg">Complete transparency at every step of the process</span>
                </li>
                <li className="flex items-start space-x-3">
                  <i className="ri-checkbox-circle-fill text-2xl text-teal-200 flex-shrink-0 mt-1"></i>
                  <span className="text-lg">Fast closings in 7-14 days with cash offers</span>
                </li>
                <li className="flex items-start space-x-3">
                  <i className="ri-checkbox-circle-fill text-2xl text-teal-200 flex-shrink-0 mt-1"></i>
                  <span className="text-lg">No repairs, no showings, no traditional listing hassles</span>
                </li>
              </ul>
            </div>
            <div className="relative">
              <img 
                src="https://public.readdy.ai/ai/img_res/2b20eb76b06977b45f5de492c8d3c8b9.jpg"
                alt="Apartment Sale Process with Title Company"
                className="rounded-xl shadow-2xl w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}